// Палитра «Тик-Так» — тёплый сказочный луг из визуального референса.
// Мягкие, насыщенные, но не кислотные цвета; тёплый естественный свет.

export const P = {
  // Небо
  skyTop: 0x8fcdf0,
  skyMid: 0xbfe4f5,
  skyHaze: 0xf3fbff,
  sunGold: 0xffe6a8,
  // Наложения времени суток
  warm: 0xffb765, // рассвет / золотой час
  dusk: 0xff7a4d, // закат
  night: 0x1a2145, // ночь / предрассвет

  sun: 0xfff3c8,
  sunCore: 0xffe07a,
  moon: 0xf2f0d8,
  star: 0xffffff,
  cloud: 0xffffff,

  // Земля / зелень (несколько планов вглубь)
  hillFar: 0xbfe08f,
  hillMid: 0xa6d477,
  hillNear: 0x8ec95c,
  meadow: 0x93cf5b,
  meadowSun: 0xc2e884,
  meadowShade: 0x6aa63e,
  dirt: 0xd8b478,

  // Дерево / дерево-часы
  wood: 0xc99a58,
  woodLight: 0xefcf94,
  woodDark: 0x7d5327,
  woodGrain: 0x5c3c1c,
  bark: 0x7a5230,
  leafDark: 0x4c8a3c,
  leaf: 0x6bb04a,
  leafLight: 0x9ad46a,

  // Вода
  water: 0x5cc1dd,
  waterDeep: 0x3a9ec2,
  waterLight: 0xb6ecf5,
  lily: 0x67bd57,

  stone: 0x9aa0a6,
  stoneLight: 0xc3c8cc,
  stoneDark: 0x6f747a,

  // Персонажи
  cuckooBody: 0xf3e2c4,
  cuckooWing: 0x9c6b3f,
  cuckooHead: 0xb07e4c,
  beak: 0xf0a53a,
  frog: 0x7cc24a,
  frogDark: 0x5aa233,
  frogBelly: 0xd8ef9e,
  snailShell: 0xb9793f,
  snailShellDark: 0x8a561f,
  snailBody: 0xe9d9b8,
  henBody: 0x9c5f34,
  henLight: 0xc78a52,
  henBelly: 0xf0dcc0,
  comb: 0xe0483a,
  chick: 0xffd24a,
  chickDark: 0xf3b32c,
  fly: 0x3a3f4a,
  flyWing: 0xdfe8f0,
  egg: 0xf6ece0,
  eggShade: 0xe0d0bc,
  salad: 0x8dc63f,
  saladDark: 0x5f9a2a,
  saladCore: 0xd6ec9a,

  petalWhite: 0xfdfdf5,
  petalYellow: 0xffd54a,
  petalPink: 0xf7a8c4,
  flowerCore: 0xffcf4d,

  ink: 0x3a2c1c, // мягкий «контур» вместо чёрного
  bubble: 0xfdfbf4,
  bubbleInk: 0x5b4a36,
} as const;

export const lerp = (a: number, b: number, f: number) => a + (b - a) * Math.max(0, Math.min(1, f));
export const clamp01 = (x: number) => Math.max(0, Math.min(1, x));

export function mix(a: number, b: number, f: number): number {
  f = Math.max(0, Math.min(1, f));
  const ar = (a >> 16) & 255,
    ag = (a >> 8) & 255,
    ab = a & 255;
  const br = (b >> 16) & 255,
    bg = (b >> 8) & 255,
    bb = b & 255;
  return (
    (Math.round(ar + (br - ar) * f) << 16) |
    (Math.round(ag + (bg - ag) * f) << 8) |
    Math.round(ab + (bb - ab) * f)
  );
}

/** Плавная кривая по ключевым кадрам {t, v}. */
export function ramp(stops: { t: number; v: number }[], t: number): number {
  if (t <= stops[0].t) return stops[0].v;
  for (let i = 0; i < stops.length - 1; i++) {
    if (t <= stops[i + 1].t) {
      const s = (t - stops[i].t) / (stops[i + 1].t - stops[i].t);
      return lerp(stops[i].v, stops[i + 1].v, s);
    }
  }
  return stops[stops.length - 1].v;
}
